import React from 'react';
import { Modal } from 'antd';
import { useTranslation } from 'react-i18next';

interface EngineValidationModalProps {
  isOpen: boolean;
  onOk: () => void;
}

const EngineValidationModal: React.FC<EngineValidationModalProps> = ({ isOpen, onOk }) => {
  const { t } = useTranslation();

  return (
    <Modal
      title={t('engineValidationTitle')}
      open={isOpen}
      onOk={onOk}
      okText={t('ok')}
      closable={false}
      cancelButtonProps={{ style: { display: 'none' } }}
      centered
    >
      <p>{t('engineValidationMessage')}</p>
    </Modal>
  );
};

export default EngineValidationModal; 